import React from 'react';

export const BowCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="32" cy="32" r="28" fill="#E6D3A3" stroke="#6D4C41" strokeWidth="2" />
      <path d="M24 16C36 24 36 40 24 48" stroke="#4E342E" strokeWidth="3" strokeLinecap="round" />
      <line x1="24" y1="16" x2="24" y2="48" stroke="#7A5A40" strokeWidth="1.5" />
      <line x1="18" y1="32" x2="48" y2="32" stroke="#6D4C41" strokeWidth="2.5" strokeLinecap="round" />
      <polygon points="48,32 41,28 41,36" fill="#6D4C41" />
      <rect x="28" y="29" width="7" height="6" rx="1" fill="#8D6E63" />
    </svg>
  );
};
